import { Routes } from '@angular/router';
import { LoggedInGuard } from './shared/guards/logged-in.guard';
import { AdminGuard } from './shared/guards/admin.guard';
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./main/main.component').then(m => m.MainComponent),
    pathMatch: 'full'
  },
  {
    path: 'opportunity',
    loadComponent: () => import('./opportunities-resources/opportunities-resources.component').then(m => m.OpportunitiesResourcesComponent)
  },
  {
    path: 'opportunity/:id',
    loadComponent: () => import('./shared/modals/offer-details-modal/offer-details-modal.component').then(m => m.OfferDetailsModalComponent)
  },
  {
    path: 'expert-database',
    loadComponent: () => import('./expert-database/expert-database.component').then(m => m.ExpertDatabaseComponent)
  },
  {
    path: 'registration',
    loadComponent: () => import('./registration/registration.component').then(m => m.RegistrationComponent),
    canActivate: [LoggedInGuard]
  },
  {
    path: 'profile',
    loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'settings',
    loadComponent: () => import('./settings/settings.component').then(m => m.SettingsComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('./about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'legal/:type',
    loadComponent: () => import('./legal-information/legal-information.component').then(m => m.LegalInformationComponent)
  },
  {
    path: 'admin',
    loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent),
    canActivate: [AdminGuard]
  },
  { path: '**', redirectTo: '' }
];